import { defineStore } from "pinia";

// Мост «действия открытого маршрута → нижняя панель» на мобильном: пока
// открыта шторка маршрута (RouteDetailsPanel в компактном режиме), App.vue
// рисует вместо вкладок кнопки Сохранить · Поделиться · Регистрация · GPX.
// Панель публикует состояние и обработчики, App только вызывает их.
export interface RouteActionsBinding {
  saved: boolean;
  canDownload: boolean;
  save: () => void;
  share: () => void;
  // Есть точка старта: «Поделиться» раскрывает подменю с этими действиями.
  hasStart?: boolean;
  copyStart?: () => void;
  open2gis?: () => void;
  openGoogleMaps?: () => void;
  register: () => void;
  download: () => void;
}

export const useRouteActionsStore = defineStore("routeActions", {
  state: () => ({ current: null as RouteActionsBinding | null }),
  actions: {
    publish(binding: RouteActionsBinding) {
      this.current = binding;
    },
    clear() {
      this.current = null;
    },
  },
});
